const productSpecificFaqs = {
  1: [
    {
      question: 'Is Blitzball Ver 2.0 good for beginners?',
      answer: 'Yes. Blitzball Ver 2.0 is beginner-friendly and also supports advanced 2A looping practice as your skill grows.',
    },
    {
      question: 'What is included with Blitzball Ver 2.0?',
      answer: 'Default setup is Gold spacer + Black spacer, plus 2 large shims and 2 small shims for tuning.',
    },
    {
      question: 'Can I choose different colors for Blitzball Ver 2.0?',
      answer: 'Yes. Multiple colorways are available on the product page, and some options have different prices.',
    },
  ],
  8: [
    {
      question: 'What is Wind Ball best for?',
      answer: 'Wind Ball is tuned for fast and responsive looping, especially for players focused on speed and rhythm control.',
    },
    {
      question: 'Do Blitzball spacers fit Wind Ball?',
      answer: 'No. The default spacer setup for Wind Ball does not fit BlitzBall, as listed in the product include notes.',
    },
    {
      question: 'Is Wind Ball available in glow and transparent colors?',
      answer: 'Yes. Wind Ball includes glow-in-the-dark and transparent style options along with solid colors.',
    },
  ],
  10: [
    {
      question: 'How many strings are in 2A String (Thin) x100?',
      answer: 'Each pack includes 100 thin strings designed for 2A yo-yo setups.',
    },
    {
      question: 'Who should buy thin 2A strings?',
      answer: 'Thin 2A strings are suitable for looping players who want stable response and smooth control.',
    },
  ],
};

const buildDefaultFaqs = (product, t, formatPrice) => {
  if (!product) return [];
  return [
    {
      question: t('product.faq.suitableQuestion', { name: product.name }),
      answer: t('product.faq.suitableAnswer', { name: product.name }),
    },
    {
      question: t('product.faq.includedQuestion', { name: product.name }),
      answer: product.include || t('product.faq.includedFallback'),
    },
    {
      question: t('product.faq.priceQuestion', { name: product.name }),
      answer: t('product.faq.priceAnswer', { price: formatPrice(Number(product.price || 0)) }),
    },
  ];
};

export const getProductFaqs = (product, t, formatPrice) => {
  if (!product) return [];
  const customFaqs = productSpecificFaqs[product.id] || [];
  return [...customFaqs, ...buildDefaultFaqs(product, t, formatPrice)];
};
